import { ReactElement, useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { GlobalStyle } from './VideoPlayer.css';

interface IVideoPlayerProps {
  options?: any;
  show?: boolean;
  onReady?: (player: any) => void;
}

const VideoPlayer = ({
  options,
  show,
  onReady,
}: IVideoPlayerProps): ReactElement => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current && videoRef.current) {
      const player = (playerRef.current = videojs(
        videoRef.current,
        options,
        () => {
          onReady && onReady(player);
        },
      ));
    }
  }, [options, videoRef]);

  useEffect(() => {
    const player = playerRef.current;
    if (!show) {
      player.hide();
    } else {
      player.show();
    }
  }, [playerRef, show]);

  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  useEffect(() => {
    if (!options.isPaused) {
      playerRef?.current.pause();
    }
  }, [options?.isPaused]);

  return (
    <div data-vjs-player>
      <GlobalStyle />
      <video
        ref={videoRef}
        className="video-js vjs-big-play-centered vjs-matrix"
      />
    </div>
  );
};

export default VideoPlayer;
